import type { Resource } from '../../';
export const country_countries_KZ: Resource = {"default":"Kazakhstan"};
